<div class="row">
    <div class="col-xl-3 col-md-6">
        <div class="card card-box card-shadow-first p-4 mb-5">
            <div class="d-flex align-items-center">
                <div class="d-40 rounded-circle bg-first text-white text-center font-size-lg mr-3">
                    <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                </div>
                <div class="text-black-50">
                    Orders
                </div>
            </div>
            <div class="display-3 text-center line-height-sm text-second text-center d-flex align-items-center pt-3 justify-content-center">
                <fa-icon [icon]="['fas', 'arrow-down']" class="font-size-sm text-danger mr-2"></fa-icon>
                <div>
                    $3,485
                </div>
            </div>
            <div class="text-black-50 text-center opacity-6 pt-3">
                <b>+36%</b> from last month
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card card-box p-4 mb-5">
            <div class="d-flex align-items-center">
                <div class="d-40 rounded-circle bg-success text-white text-center font-size-lg mr-3">
                    <fa-icon [icon]="['far', 'file-excel']"></fa-icon>
                </div>
                <div class="text-black-50">
                    Reports
                </div>
            </div>
            <div class="display-3 text-center line-height-sm text-second text-center d-flex align-items-center pt-3 justify-content-center">
                <fa-icon [icon]="['far', 'dot-circle']" class="font-size-sm text-warning mr-2"></fa-icon>
                <div>
                    436
                </div>
            </div>
            <div class="text-black-50 text-center opacity-6 pt-3">
                <b>+65%</b> from last month
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card card-box p-4 mb-5">
            <div class="d-flex align-items-center">
                <div class="d-40 rounded-circle bg-danger text-white text-center font-size-lg mr-3">
                    <fa-icon [icon]="['far', 'user']"></fa-icon>
                </div>
                <div class="text-black-50">
                    Customers
                </div>
            </div>
            <div class="display-3 text-center line-height-sm text-second text-center d-flex align-items-center pt-3 justify-content-center">
                <fa-icon [icon]="['fas', 'arrow-up']" class="font-size-sm text-success mr-2"></fa-icon>
                <div>
                    4867
                </div>
            </div>
            <div class="text-black-50 text-center opacity-6 pt-3">
                <b>+22%</b> from last month
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card card-box bg-premium-dark p-4 mb-5">
            <div class="d-flex align-items-center">
                <div class="d-40 rounded-circle bg-first text-white text-center font-size-lg mr-3">
                    <fa-icon [icon]="['far', 'user']"></fa-icon>
                </div>
                <div class="text-white-50">
                    Sales
                </div>
            </div>
            <div class="display-3 text-center line-height-sm text-white-50 text-center d-flex align-items-center pt-3 justify-content-center">
                <fa-icon [icon]="['fas', 'arrow-down']" class="font-size-sm text-first mr-2"></fa-icon>
                <div>
                    433
                </div>
            </div>
            <div class="text-white-50 text-center opacity-6 pt-3">
                <b>+32%</b> from last month
            </div>
        </div>
    </div>
</div>
